import React from 'react';

interface Props {
  onClick: () => void;
  label?: string;
  'aria-label'?: string;
  /** Extra spacing (in rem) above the default resting position — use when another
   * fixed bar (e.g. a bottom action bar) sits above the normal bottom nav on this screen. */
  bottomOffsetRem?: number;
}

export function FAB({ onClick, label, 'aria-label': ariaLabel, bottomOffsetRem = 0 }: Props) {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel ?? label ?? 'Adicionar'}
      className={[
        'fixed z-40 right-4 bg-emerald-500 text-white',
        'rounded-full shadow-lg hover:bg-emerald-600 active:bg-emerald-700',
        'transition-colors touch-manipulation',
        'flex items-center justify-center',
        label
          ? 'h-14 px-5 gap-2 text-base font-semibold'
          : 'w-14 h-14',
      ].join(' ')}
      style={{ bottom: `calc(4rem + env(safe-area-inset-bottom) + 12px + ${bottomOffsetRem}rem)` }}
    >
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      {label && <span>{label}</span>}
    </button>
  );
}
